import { DEFAULT_LOCALE } from "../money";

export type Messages = Readonly<Record<string, string>>;
export type Catalogue = Readonly<Record<string, Messages>>;

/** The catalogues to look in for a locale, best first: `en-IN`, then `en`, then the default. */
export function catalogueChain(catalogue: Catalogue, locale: string): Messages[] {
  const language = locale.split("-")[0] ?? locale;
  const tags = [locale, language, DEFAULT_LOCALE, DEFAULT_LOCALE.split("-")[0] ?? DEFAULT_LOCALE];
  return [...new Set(tags)].flatMap((tag) => (catalogue[tag] ? [catalogue[tag]] : []));
}
